<app-floorplan-product-menu
  [title]="tooltipTextKvms"
  [hasConfigurations]="kvms.length > 0"
  [visible]="floorplan.floorplanState.kvmsVisible"
  [locked]="floorplan.floorplanState.kvmsLocked"
  [itemTextVisible]="floorplan.floorplanState.kvmsItemTextVisible"
  (visibilityUpdate)="floorplan.floorplanState.kvmsVisible = $event"
  (lockUpdate)="floorplan.floorplanState.kvmsLocked = $event"
  (itemTextVisibilityUpdate)="updateKvmsItemTextVisibility($event)"
  (addPlaceholderToFloorplan)="addPlaceholder()"
  (dragPlaceholder)="dragPlaceholder()"
  configPath="kvm"
>
  @for (kvm of kvms; track kvm) {
    <div>
      <hr />
      <app-configured-product
        [productConfiguration]="kvm"
        [imageUrl]="(getImageUrl$(kvm) | async) || getFallbackImageUrl(kvm)"
        [fallbackImageUrl]="getFallbackImageUrl(kvm)"
        [numberOfFloorplanItems]="floorplan.countPlacedKvms(kvm)"
        [attachments]="[]"
        (add)="addKvm(kvm)"
        (delete)="deleteKvm(kvm)"
        (dragStart)="drag(kvm)"
        editPath="kvm"
      >
      </app-configured-product>
    </div>
  }
</app-floorplan-product-menu>
